export enum Cost {
  Cheap = 1,
  Reasonable,
  Expensive,
}

export enum Meal {
  Breakfast = 1,
  Lunch,
  Dinner,
  Pastry,
  Bready
}
